import React from 'react';
import PropTypes from 'prop-types';

// Cropped Core foundation Tempus | Progeny lockup (logos/progeny-black.svg).
export const ProgenyLogo = ({ width, height }) => (
  <svg
    aria-label="Tempus Progeny"
    fill="none"
    height={height}
    role="img"
    viewBox="0 0 178 16"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.7443 10.8677V13.4613H15.1903V2.49394H24.6522V5.07315H18.3596V6.57865H24.1686V9.22119H18.3596V10.8677H24.7443Z"
      fill="currentColor"
    />
    <path
      d="M41.584 2.49394V13.4613H38.4463V7.58903L36.1924 13.4613H32.6978L30.4439 7.58903V13.4613H27.3062V2.49394H31.5492L34.4537 9.90341L37.3582 2.49394H41.584Z"
      fill="currentColor"
    />
    <path
      d="M49.6613 5.07315H47.4246V7.52858H49.6929C50.686 7.52858 51.1063 7.21769 51.1063 6.30231C51.1063 5.38692 50.6544 5.07603 49.6613 5.07603V5.07315ZM49.5979 10.1222H47.4217V13.4613H44.2524V2.49394H49.6123C52.6579 2.49394 54.3361 3.82961 54.3361 6.29943C54.3361 8.76925 52.6435 10.1222 49.5979 10.1222Z"
      fill="currentColor"
    />
    <path
      d="M56.4029 2.49394H59.5722V8.76925C59.5722 9.37375 59.7593 9.90341 60.1163 10.3697C60.4732 10.8361 61.095 11.0692 61.9499 11.0692C62.8049 11.0692 63.441 10.8361 63.798 10.3697C64.1549 9.90341 64.342 9.37663 64.342 8.76925V2.49394H67.5113V8.53609C67.5113 10.3064 66.9989 11.6133 65.9742 12.451C64.9638 13.2886 63.6137 13.7089 61.9499 13.7089C60.2861 13.7089 58.936 13.2886 57.9257 12.451C56.9153 11.6133 56.4029 10.3064 56.4029 8.53609V2.49394Z"
      fill="currentColor"
    />
    <path
      d="M70.3525 10.1682C70.8332 10.4014 71.4233 10.6202 72.1401 10.8044C72.8712 10.9742 73.5535 11.0692 74.2069 11.0692C75.4648 11.0692 76.0866 10.8677 76.0866 10.4647C76.0866 10.0128 75.4188 9.7969 74.1896 9.54934C74.0198 9.53495 73.8327 9.48602 73.5995 9.42557C71.0203 8.83546 69.5753 8.12157 69.5292 5.72659C69.5292 4.56077 69.9955 3.69143 70.9426 3.11572C71.8896 2.54 73.1188 2.24639 74.6243 2.24639C76.1298 2.24639 77.9491 2.635 79.207 3.30283L78.1966 5.6172C77.0625 5.16527 75.603 4.90332 74.5466 4.90332C73.3808 4.90332 72.7302 5.15087 72.7302 5.58842C72.7302 6.02596 73.352 6.22458 74.4861 6.42609L74.9381 6.5182C76.3198 6.81469 77.3935 7.21769 78.1534 7.76175C78.9134 8.2914 79.302 9.08302 79.302 10.1395C79.302 11.3369 78.8213 12.2379 77.8569 12.828C76.8955 13.4182 75.6347 13.7146 74.0831 13.7146C73.2455 13.7146 72.3905 13.6053 71.5183 13.3721C70.649 13.1389 69.9034 12.8424 69.2961 12.4711L70.3525 10.1711V10.1682Z"
      fill="currentColor"
    />
    <path d="M0 5.05588H1.40187V2.49394H0V5.05588Z" fill="currentColor" />
    <path d="M2.14742 5.05588H4.70936V2.49394H2.14742V5.05588Z" fill="currentColor" />
    <path d="M5.76867 13.4613H8.93799V5.05588H10.7544V2.49394H5.76867V13.4613Z" fill="currentColor" />
    <path d="M11.4999 2.49394V5.05588H12.5564V2.49394H11.4999Z" fill="currentColor" />
    <path
      d="M173.935 13.4559H172.16V9.13653L168.39 2.49253H170.417L173.087 7.37736H173.134L175.788 2.49253H177.736L173.935 9.10512V13.4559Z"
      fill="currentColor"
    />
    <path
      d="M163.013 13.4559L159.432 7.39307L158.222 5.06846H158.175V13.4559H156.479V2.49253H158.458L162.039 8.55538L163.248 10.88H163.296V2.49253H164.992V13.4559H163.013Z"
      fill="currentColor"
    />
    <path
      d="M152.312 13.4559H145.291V2.49253H152.312V4.06322H147.066V7.11035H151.825V8.68103H147.066V11.8852H152.312V13.4559Z"
      fill="currentColor"
    />
    <path
      d="M139.392 13.4559V11.791H139.329C139.109 12.8433 138.041 13.6444 136.376 13.6444C133.769 13.6444 131.853 11.6496 131.853 7.97422C131.853 4.31453 133.769 2.30405 136.643 2.30405C138.607 2.30405 139.973 3.23076 140.727 4.77003L139.282 5.6182C138.858 4.59725 137.978 3.89044 136.643 3.89044C134.915 3.89044 133.753 5.06846 133.753 7.07893V8.86951C133.753 10.88 134.915 12.058 136.643 12.058C138.025 12.058 139.235 11.3512 139.235 9.9847V9.13653H136.973V7.61297H140.947V13.4559H139.392Z"
      fill="currentColor"
    />
    <path
      d="M123.521 13.6444C120.663 13.6444 118.794 11.6653 118.794 7.97422C118.794 4.28311 120.663 2.30405 123.521 2.30405C126.38 2.30405 128.249 4.28311 128.249 7.97422C128.249 11.6653 126.38 13.6444 123.521 13.6444ZM123.521 12.058C125.218 12.058 126.349 10.8329 126.349 8.8381V7.11035C126.349 5.11558 125.218 3.89044 123.521 3.89044C121.825 3.89044 120.694 5.11558 120.694 7.11035V8.8381C120.694 10.8329 121.825 12.058 123.521 12.058Z"
      fill="currentColor"
    />
    <path
      d="M109.04 9.02658V13.4559H107.265V2.49253H111.992C113.956 2.49253 115.165 3.76479 115.165 5.79097C115.165 7.34595 114.427 8.42972 113.029 8.8381L115.401 13.4559H113.422L111.223 9.02658H109.04ZM109.04 7.53443H111.867C112.762 7.53443 113.296 7.04752 113.296 6.16794V5.41401C113.296 4.53442 112.762 4.04751 111.867 4.04751H109.04V7.53443Z"
      fill="currentColor"
    />
    <path
      d="M97.3151 13.4559H95.5402V2.49253H100.252C102.263 2.49253 103.441 3.7962 103.441 5.79097C103.441 7.78574 102.263 9.08941 100.252 9.08941H97.3151V13.4559ZM97.3151 4.04751V7.53443H100.142C101.038 7.53443 101.572 7.04752 101.572 6.16794V5.41401C101.572 4.53442 101.038 4.04751 100.142 4.04751H97.3151Z"
      fill="currentColor"
    />
    <path d="M86.6976 16V0H87.9165V16H86.6976Z" fill="currentColor" />
  </svg>
);

ProgenyLogo.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};
